var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full mb-20 relative"},[_c('div',{staticClass:"mt-40 md:px-24"},_vm._l((_vm.categories),function(category){return _c('two-column-projects',{attrs:{"category":category}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }